var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNocolour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.59,
    height: 13.626,
    viewBox: "0 0 15.59 13.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.795 13.626L0 0h15.59z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNocolour);
export default __webpack_public_path__ + "static/media/Arrow-nocolour.2c1ff43b7e4fbaf2f8c1f02c519279b5.svg";
export { ForwardRef as ReactComponent };